<mat-card>
    <mat-card-content>
    <mat-form-field>
        <mat-label>Product</mat-label>
        <mat-select [(value)]="selectedProduct" (selectionChange)="productChange($event)">
            <mat-option *ngFor="let product of products" [value]="product">
                <div fxLayout="row" fxLayoutAlign="start center">
                <div class="m-r-10 chart-select-color" [style.background-color]="product.productColor"></div><div>{{product.product}}</div>
                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>
    </mat-card-content>
</mat-card>
<mat-card>
    <mat-card-content>
        <app-warp-environments [environments]="environments"
            [selectedCompany]="selectedCompany?.name" [selectedProduct]="selectedProduct?.productName" [allowEdit]="isSituUser"
            (reloadEnvironmentsEvent)="loadEnvironments()">
        </app-warp-environments>
    </mat-card-content>
</mat-card>